import React, { Component } from 'react'
import './index.css';
import Table from 'react-bootstrap/Table';
import ReactLoading from 'react-loading';
import ColoredTD2 from './colored_td2.js';
import moment from 'moment';
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import store from "./store/index";
import WinnerBox from './components/UI/WinnerBox'
import axios from 'axios';
import { Button, FormGroup, FormControl, FormLabel, Image } from "react-bootstrap";

const textStyle1 = {
  fontSize: '14px',
}
const alignCenter = {
  align: "center",
}
const API_WINNER = 'https://rpmapi.makebettinggreat.com/v1/horse/winners/';

class Drifters extends Component {
  timer = null;
  currentRaceInUkTime = timeInHHMM => moment(timeInHHMM, 'HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes').format('HH:mm');
  horseIcon = <Image width={25} height={25} src={require('./assets/horse_icon.jpg')} />
  harnessIcon = <Image width={25} height={25} src={require('./assets/harness_icon.jpg')} />
    constructor(props) {
    super(props);
    this.state = {
      sortConfig: {
        key: null,
        direction: null,
      },
    };
     this.sortBySelectedOrder = this.sortBySelectedOrder.bind(this);
  }

  extractTimeColumn = (market, raceTime) => {
    //var first   = market.split(" ")[0];
    var second = raceTime.split("-")[1];
    const localTime = this.currentRaceInUkTime(second);
    //if (first.startsWith("R")){
    // return  first+": "+ localTime
    //}
    //else{
    return localTime
    //}
  }

  async componentDidMount() {
    this.addRefresher()
  }

  addRefresher() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
    this.refreshOdd();
    this.timer = setInterval(() => {
      this.refreshOdd()
    }, 2000)
  }

   componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  sortByMovementPercentage(first, second) {
    try {
      return Math.abs(second.movementPercentage) - Math.abs(first.movementPercentage);
    } catch (e) {
      console.log("Error in sorting by time :" + e);
      return 0;
    }
  }
  
  refreshOdd() {
    const urlPrefix = "https://rpmapi.makebettinggreat.com/v1/horse/latest-odd";
    const itemTorefresh = this.props
    .array
    .filter(item => !moment.utc(item.raceTime, "YYYYMMDD-HH:mm", "Etc/GMT").isBefore(moment.tz("Etc/GMT")))
    .map(item => ({selectionId: item.selectionId, marketId: item.bfMarketId}));
    if (itemTorefresh.length === 0 || !this.props.refresh) {
      return;
    }
    axios.post(urlPrefix, itemTorefresh).then(response => {
        if (response.status === 200) {
          const data = response.data;
          data.forEach(updatedItem => {
            const index = this.props.array.findIndex(item => item.selectionId === updatedItem.selectionId);
            if (index !== -1) {
              const originalItem = this.props.array[index];
              const priceAtTime = originalItem.priceAtTime;
              const currentPrice = updatedItem.bestBackOdd;
              const movementPercentage = ((currentPrice - priceAtTime) / priceAtTime) * 100;
              this.props.array[index] = {
                ...originalItem,
                currentPrice: currentPrice,
                movementPercentage: movementPercentage.toFixed(2)
              };
            }
          });
          //this.props.onUpdate(this.props.array);
          //console.log("Refreshed drifters data :" + JSON.stringify(data));
        }
      });
       this.setState({
      array: this.props.array
    });
  }

  sortByTime(first, second) {
    try {
      const a = this.extractTimeColumn(first["bfMarketName"], first["raceTime"])
      const b = this.extractTimeColumn(second["bfMarketName"], second["raceTime"])
      //console.log("vivek A : " + a + " B : " + b);
      const [ah, am] = a.split(":").map(Number);
      const [bh, bm] = b.split(":").map(Number);
      const aMinutes = ah * 60 + am;
      const bMinutes = bh * 60 + bm;
      return aMinutes - bMinutes;
    } catch (e) {
      console.log("Error in sorting by time :" + e);
      return 0;
    }
  }

    getRaceNumber(marketName) {
    try {
      const match = marketName.match(/R\d+/);
      return match ? match[0] : "";
    } catch (e) {
      console.log("Error in sorting by time :" + e);
      return ""
    }
  }

  handleSort = (key) => {
    const { sortConfig } = this.state;
    let direction = "asc";
    // toggle between asc / desc
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    this.setState({
      sortConfig: { key, direction },
    });
   console.log("Sorting requested for key :" + key + " direction :" + direction);
   this.handleSort2(key, direction);
  };

  sortBySelectedOrder(a, b) {
    try {
      const { sortConfig } = this.state;
      if (!sortConfig.key || !sortConfig.direction) {
        return 0;
      }
      const key = sortConfig.key;
      const direction = sortConfig.direction;
      if (key === "raceTime") {
        const dateA = new Date(
          a.raceTime.replace(/(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2})/, "$1-$2-$3T$4:$5:00Z")
        );
        const dateB = new Date(
          b.raceTime.replace(/(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2})/, "$1-$2-$3T$4:$5:00Z")
        );
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }
      if (key === "movementPercentage") {
        return direction === "asc" ? Math.abs(a.movementPercentage) - Math.abs(b.movementPercentage)
          : Math.abs(b.movementPercentage) - Math.abs(a.movementPercentage);
      }
    } catch (e) {
      console.log("Error in sorting by selected order :" + e);
    }
    return 0;
  }

   getIcon = (key) => {
      const { sortConfig } = this.state;
      if (sortConfig.key !== key) return <FaSort className="ms-1" />;
      if (sortConfig.direction === "asc") return <FaSortUp className="ms-1" />;
      return <FaSortDown className="ms-1" />;
    };

    handleSort2(key, direction) {
    if (this.props.array.length === 0) {
      return;
    }
    const sorted = this.props.array
    .sort((a, b) => {
      if (key === "raceTime") {
        const dateA = new Date(
          a.raceTime.replace(/(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2})/, "$1-$2-$3T$4:$5:00Z")
        );
        const dateB = new Date(
          b.raceTime.replace(/(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2})/, "$1-$2-$3T$4:$5:00Z")
        );
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }
      if (key === "movementPercentage") {
        return direction === "asc" ? Math.abs(a.movementPercentage) - Math.abs(b.movementPercentage)
         : Math.abs(b.movementPercentage) - Math.abs(a.movementPercentage);
      }
    });
    this.setState({
      array: sorted
    });
  };

  render() {
    let loadingElement = null
    //console.log("LOADING STILL intial : "+this.props.array.length);
    if (this.props.array.length > 0) {
      //console.log("LOADING STILL finised");
    } else {
      //console.log("LOADING STILL");
      //loadingElement = <ReactLoading type="spokes" color="green" height={200} width={200} className="alignCenter24" />
      loadingElement = <div style={{fontSize:"medium", fontWeight:"500"}} align="center" >Drifters information not available</div>

    }

    
    return (
      <div>
        <div align="center" class="divblocks24">Drifters</div>
        <Table striped bordered hover style={textStyle1} size="sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Venue</th>
             <th scope="col" onClick={() => this.handleSort("raceTime")} style={{ cursor: "pointer" }}>
                  Time {this.getIcon("raceTime")}
              </th>
              <th scope="col">Runner</th>
              <th scope="col">Price at ({this.props.t0Time})</th>
              <th scope="col">Current Price</th>
              <th scope="col" onClick={() => this.handleSort("movementPercentage")} style={{ cursor: "pointer" }}>
                Movement{this.getIcon("movementPercentage")}</th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.array
               // .sort((a, b) => this.sortByMovementPercentage(a, b))
                .filter(a => a.movementPercentage >= 0)
                 .sort(this.sortBySelectedOrder)
                .map((element, index) => {
                  let winnerBox = element["winnerIndicator"] ? <WinnerBox winnerColor="red" loserColor="green" type={element["winnerIndicator"]} /> : null
                  let isHarness = element["bfMarketName"].includes("Pace") || element["bfMarketName"].includes("Trot")
                  let raceTypeIcon = isHarness ? this.harnessIcon : this.horseIcon
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{element["raceVenue"]}{'    '}{this.getRaceNumber(element["bfMarketName"])}</td>
                      <td>{this.extractTimeColumn(element["bfMarketName"], element["raceTime"])}</td>
                      <td style={{ display: "flex" }}>{raceTypeIcon} {element["runnerName"]}{winnerBox}</td>
                      <td>{element["priceAtTime"]}</td>
                      <td>{element["currentPrice"]}</td>
                      <ColoredTD2 value={element["movementPercentage"]} />
                    </tr>
                  )
                }
                )
            }
          </tbody>
        </Table>
        <div style={alignCenter}>
          {this.props.loading ? <center style={{fontSize:"medium", fontWeight:"500"}}>Loading...</center> : loadingElement}
        </div>
      </div>
    )
  }
}
export default Drifters
